<template>
	<eui-panel
		vp-huvud-text="Okänd widget"

		:vp-inaktiverad="skaVaraInaktiverad"
		:disabled="skaVaraInaktiverad"
		:vp-osynlig="skaVaraOsynlig"
		:class="{
			'-osynlig':skaVaraOsynlig
		}"

		:vp-visa-menyfaltet="vpArIRedigeralage"
		:vp-meny-config.sync="menyConfig"

		style="width: 100%; height: 100%;"

		@menyalternativ-valt-i-panel="onMenyalternativValtIPanel"
	>
		<!--<span v-if="vpArIRedigeraLage" @click="onDeleteWidget" style="float: right; cursor:pointer;">X</span>-->

		<!--v-html="vpWidgetData.html"-->
		<!--	:class="{ '-inaktiverad':this.vpArIRedigeralage || this.$parent.isDragging || this.$parent.isResizing }"-->


		<!-- Kroppen (default slot): -->
		<div>
			<p class="mellan ellipsis">Widget id: {{ vpWidgetId }}</p>
			<p class="mellan styckemellanrum-inget ellipsis">Element name: {{ vpWidgetOriginalElementName }}</p>
			<p class="mellan styckemellanrum-inget ellipsis">Parameters: {{ vpWidgetParameters }}</p>
			<p class="mellan styckemellanrum-inget ellipsis">Settings1: {{ vpWidgetSettings }}</p>
			<p class="mellan styckemellanrum-inget ellipsis">Settings2: {{ vpWidgetData.settings }}</p>
			<p class="mellan styckemellanrum-inget ellipsis">Exception: {{ vpWidgetData.exception }}</p>
		</div>
	</eui-panel>
</template>


<script>
// ################################################################################################################

	import euiPanel from 'v-components/euiPanel';
	import { ssoGeneriskWidgetMixin } from 'v-mixins/ssoGeneriskWidgetMixin';

	export default {
		name: 'unknownwidget',

		// All generisk widgetfunktionalitet, se 'ssoGeneriskWidgetMixin.js'.
		mixins: [ssoGeneriskWidgetMixin],

		// Lokalt registrarade komponenter
		components: {
			[euiPanel.name]: euiPanel,
		},

		//// Props utöver de från mixin ovan:
		//props: {
		//},


		//== Lifecycle hooks  ================================================================================================================

	}
</script>

